var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.imgList&&_vm.imgList.length>0)?_c('el-image',{style:({width:_vm.width+'px',height:_vm.height+'px'}),attrs:{"preview-src-list":_vm.imgList,"src":_vm.imgList[0],"fit":"cover"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }